import React from 'react';

export default function CertificateManagement() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Certificate Management</h1>
      <p>Manage certificates here.</p>
    </div>
  );
} 